import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { BaseService } from './base.service';
import { environment } from '../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DirectRfqService extends BaseService {
    private baseApiUrl: string;
    private baseDynamoApiUrl: string;

    constructor(
        private apiService: ApiService
    ) {
        super();
        this.baseDynamoApiUrl = environment.DynamoDBAPI;
        this.baseApiUrl = environment.APIEndpoint;

    }

    getAllDirectRFQsByCompanyId(companyId: number): Observable<any> {
        return this.apiService.get<any>(
            this.baseDynamoApiUrl,
            `rfq/GetAllDirectRFQsByCompanyId?companyId=${companyId}`
        );
    }


    downloadPdf(companyId: number, rfqId: string,contactId:number): Observable<any> {
        return this.apiService.get<any>(
            this.baseDynamoApiUrl,
            `supplier/GetSupplierDirectRfqQuotePdfData?companyId=${companyId}&rfqId=${rfqId}&contactId=${contactId}`
        );
    }
    updateSeenTime(rfqId: string, contactId: number, companyId: number): Observable<any> {
        return this.apiService.post<any>(
            this.baseDynamoApiUrl,
            `rfq/UpdateRFQSeenTime?rfqId=${rfqId}&contactId=${contactId}&companyId=${companyId}`,
            null
        );
    }

    sideDrawerRfqData(params: {
        companyId: string | number,
        contactId: string | number,
        integration: string,
        isTrackingEnabled: boolean,
        rfqId: string
    }): Observable<any> {
        return this.apiService.get<any>(
            this.baseDynamoApiUrl,
            `rfq/GetRfqDetailsForSideDrawer?companyId=${params.companyId}&contactId=${params.contactId}&rfqId=${params.rfqId}&integration=${params.integration}`
        );
    }

    getDirectRfqList(params: any): Observable<any> {
        return this.apiService.get<any>(this.baseApiUrl, 'RFQ/GetDirectRFQList', params);
    }
}